module.exports = __webpack_public_path__ + "static/checkin.7e379190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkin.jpg
// module id = 463
// module chunks = 207076274901000